// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__Nk4w8","sidebar":"styles_sidebar__Vd-0+","main":"styles_main__PvBem","title":"styles_title__OiUqu"};